var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"input",attrs:{"id":_vm.id,"type":_vm.type,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":function($event){_vm.type === 'checkbox' && _vm.change($event.target.value)},"click":function($event){_vm.type === 'radio' && _vm.change(!_vm.checked)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }